import { CreationDateSortOptions } from "src/enums";
import { DateTimeRange, PostVendorsExportsRequestBody, VendorsFilters, VendorsFiltersState } from "src/types";

export class ExportVendorMapper {
  public static createVendorsExportsRequestBody(
    dateTimeRange?: DateTimeRange,
    filters?: VendorsFiltersState,
    sort?: CreationDateSortOptions
  ): PostVendorsExportsRequestBody {
    const createdAtStart = dateTimeRange?.start?.toISOString();
    const createdAtEnd = dateTimeRange?.end?.toISOString();

    const normalisedDateTimeRange = { createdAtStart, createdAtEnd };

    const normalisedFilters: VendorsFilters = {
      vendorName: filters?.vendorName,
      location: filters?.location,
      createdByUserEmail: filters?.createdByUserEmail,
      portalOrderVendor: filters?.portalOrderVendor,
      collectionOrderVendor: filters?.collectionOrderVendor,
      portalAccess: filters?.portalAccess,
      isProForma: filters?.isProForma,
      fileType: filters?.fileTypes && filters.fileTypes.length > 0 ? filters.fileTypes : undefined,
      emails: filters?.emails
    };

    const requestBody: PostVendorsExportsRequestBody = {
      dateTimeRange: normalisedDateTimeRange,
      filters: normalisedFilters,
      sort
    };

    return requestBody;
  }
}
